import { type Chart, type Plugin } from "chart.js";
import { set } from "lodash";
import { type ChartJSOrUndefined } from "react-chartjs-2/dist/types";

export const CHART_DATA_MANAGER_ID = "chartDataManager";

export type ChartDataManagerPluginOptions = {
  data: { datasets: any[] };
  datasetVisibility: Record<string, boolean>;
  getBucketFromSpendValue: (spend: number) => string;
};

export const chartDataManagerPlugin: Plugin = {
  id: CHART_DATA_MANAGER_ID,
};

export const getChartData = (
  chart: Chart<any>,
): ChartDataManagerPluginOptions =>
  chart.config.options.plugins[CHART_DATA_MANAGER_ID];

const setDatasetVisibility = (
  chart: Chart<any>,
  datasetVisibility: Record<string, boolean>,
) => {
  Object.entries(datasetVisibility).forEach(([datasetId, isVisible]) => {
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (dataset.yAxisID === datasetId) {
        set(chart, `config.data.datasets[${datasetIndex}].hidden`, !isVisible);
      }
    });
  });
};

export const setChartData = (
  chart: ChartJSOrUndefined | null,
  chartData: ChartDataManagerPluginOptions,
) => {
  if (!chart) {
    return;
  }

  setDatasetVisibility(chart, chartData.datasetVisibility);
  set(chart, `config.options.plugins.${CHART_DATA_MANAGER_ID}`, chartData);
  chart.update();
};
